import { normalizeEmail } from "../shared/email.js";

export const SIGNUP_SESSION_KEY = "thejuggernaut.signup-session";

interface StorageReader {
  getItem(key: string): string | null;
}

interface StorageWriter extends StorageReader {
  setItem(key: string, value: string): void;
}

interface StoredSignupSession {
  version: 1;
  email: string;
}

export type SignupSession =
  | { state: "none" }
  | { state: "valid"; email: string }
  | { state: "invalid"; email: string };

export function readSignupSession(storage: StorageReader): SignupSession {
  let serialized: string | null;

  try {
    serialized = storage.getItem(SIGNUP_SESSION_KEY);
  } catch {
    return { state: "none" };
  }

  if (serialized === null) {
    return { state: "none" };
  }

  try {
    const session = JSON.parse(serialized) as Partial<StoredSignupSession>;
    if (session.version !== 1 || typeof session.email !== "string") {
      return { state: "none" };
    }

    const normalizedEmail = normalizeEmail(session.email);
    return normalizedEmail
      ? { state: "valid", email: normalizedEmail }
      : { state: "invalid", email: session.email };
  } catch {
    return { state: "none" };
  }
}

export function saveSignupSession(
  storage: StorageWriter,
  email: string
): boolean {
  const normalizedEmail = normalizeEmail(email);
  if (!normalizedEmail) {
    return false;
  }

  try {
    storage.setItem(
      SIGNUP_SESSION_KEY,
      JSON.stringify({ version: 1, email: normalizedEmail })
    );
    return true;
  } catch {
    return false;
  }
}
